export default "__VITE_ASSET__4f4dc7af__"